export default __webpack_public_path__ + "static/media/dobro_negativ.be82a63c.svg";